import { Request } from "./request";

export interface ProvinceParams {
  timeHead?: string;
  timeTail?: string;
}

export interface ProvinceOverViewProps {
  regionCode?: string;
  scope?: number;
}

export interface ErrorDistributionParams {
  ps?: number;
  regionCode?: string;
  scope?: number;
}

export interface StaticDataProps {
  type?: string;
  regionCode?: string;
  startTime?: string;
}

export interface WarningRuleProps {
  regionCode?: string;
  startTime?: string;
}
export interface CountyRuleUseProps {
  dType?: number;
  regionCode?: string;
  scope?: number;
}
export interface organizationProps {
  regionCode?: string;
  scope?: number;
}

//省地图数据 + 近一年行为变化图
export function getProvinceMapAndAnaylseAndLastYaer(
  regionCode?: string
): Request {
  return {
    url: "/api/dashboard/area",
    method: "GET",
    params: {
      regionCode,
    },
  };
}

//省监管数据总览
export function getProvinceOverview(params: ProvinceOverViewProps): Request {
  return {
    url: "/api/analysis/area/index",
    method: "GET",
    params,
  };
}

// 县数据总览
export function getCityOverview(params: ProvinceOverViewProps): Request {
  return {
    url: "/api/analysis/caution/rule/area/index",
    method: "GET",
    params,
  };
}

//诊疗异常行为分布
export function getErrorDistribution(params: ErrorDistributionParams): Request {
  return {
    url: "/api/statistic/medical/caution/distribute",
    method: "GET",
    params,
  };
}

// 监管占比
export function getStaticData(params: StaticDataProps): Request {
  return {
    url: "/api/statistic/data/type",
    method: "GET",
    params,
  };
}
// 监管机构类型占比数据
export function getRegulatoryData(regionCode?: string): Request {
  return {
    url: "/api/statistic/unit/type",
    method: "GET",
    params: { regionCode },
  };
}

// 预警占比
export function getWarningRuleData(params: WarningRuleProps): Request {
  return {
    url: "/api/analysis/dispose/time/area",
    method: "GET",
    params,
  };
}

// 县一级平均处理事件
export function getCountyRuleData(params: WarningRuleProps): Request {
  return {
    url: "/api/analysis/dispose/time/caution/rule",
    method: "GET",
    params,
  };
}

// 县一级预警执法占比事件
export function getCountyRuleUseData(params: CountyRuleUseProps): Request {
  return {
    url: "/api/analysis/caution/rule/usage",
    method: "GET",
    params,
  };
}

//机构占比
export function getOrganizationData(params: organizationProps): Request {
  return {
    url: "/api/analysis/org/supervise/access/percentage",
    method: "GET",
    params,
  };
}
